export enum RuleType {
  Fijo,          // monto fijo
  PorKm,         // se multiplica por la cantidad de km
  Porcentaje,    // se calcula sobre otro monto
  PorTiempo      // ej: cada 10 minutos
}
